import { Component, OnInit, ViewChild } from '@angular/core';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../services/MessageService';
import { Message } from 'primeng/api/message';
import { utility } from '../../common/utility';
import { AlertService } from 'src/app/services/AlertService';
import { LazyLoadEvent } from 'primeng/api';
import { DataView } from 'primeng/dataview';

@Component({
  selector: 'app-message-view',
  templateUrl: './message-view.component.html',
  styleUrls: ['./message-view.component.scss']
})
export class MessageViewComponent implements OnInit {
    messages: any[];
    options: any;
    messageSourceTypeOptions: any[] = [];
    selectedMessageSourceTypeId: any;
    msgs: Message[];
    isFav: boolean = false;    
    showSettingDialog: boolean = false;
    propertyTypeOptions: any[] = [];
    dealTypeOptions: any[] = [];
    userSettings: any;
    cloneUserSettings: any;
    rowsPerPageOptions: number[] = utility.RowsPerPageOptions;
    //loading: boolean = false;
    totalRecords: number;
    rowsPerPage: number = 5;
    isPaginator: boolean = true;
    searchText: string = '';
    @ViewChild('dv', { static: false }) dataView: DataView;

    constructor(private breadcrumbService: AppBreadcrumbService,
                private activatedRoute: ActivatedRoute,
                private messageService: MessageService,
                private alertService: AlertService) { }

    ngOnInit(): void {
        this.breadcrumbService.setItems([
            this.breadcrumbService.messageBoard
        ]);

        this.options = this.activatedRoute.snapshot.data['options'];
        this.parseOptions();
        this.userSettings = this.options[3];
        this.selectedMessageSourceTypeId = 1;
        //this.messages = this.options[4];

        this.cloneUserSettings = utility.cloneObject(this.userSettings);        
        this.InitCheckboxOptions();       
    }

    searchMessage() {        
        this.selectedMessageSourceTypeId = 1;
        this.messageSourceTypeOnChange();        
    }

    lazyLoadMessages(event: LazyLoadEvent) {
        this.loadMessages(event.first, event.rows, this.searchText);
    }

    loadMessages(first, numberOfRow, searchText) {
        //this.loading = true;
        this.messageService.GetMessagesBySourceTypeId(this.selectedMessageSourceTypeId, first, numberOfRow, searchText).subscribe(
            result => {
                //this.loading = false;
                this.messages = result.Messages;        
                this.totalRecords = result.TotalMessages;
            },
            error => {
                this.alertService.SetMessage('error', 'There is an error while loading messages');
            }
        );
    }

    InitCheckboxOptions() {
        //these code for default primeng check boxes value not working     
        this.userSettings.PropertyTypeList = [];
        this.userSettings.DealTypeList = [];

        for (let pt of this.cloneUserSettings.PropertyTypeList) {
            var opt = this.propertyTypeOptions.find(x => x.Id === pt.Id);
            if(opt != null)
                this.userSettings.PropertyTypeList.push(opt);
            
        }

        for (let dt of this.cloneUserSettings.DealTypeList) {
            var opt = this.dealTypeOptions.find(x => x.Id === dt.Id);
            if (opt != null)
                this.userSettings.DealTypeList.push(opt);

        }
    }

    parseOptions() {
        this.messageSourceTypeOptions = new Array();
        for (let o of this.options[0]) {
            let l = o.Description;
            this.messageSourceTypeOptions.push({ label: l, value: o.Id });
        }

        this.propertyTypeOptions = new Array();
        for (let o of this.options[1]) {
            let l = o.Description;
            this.propertyTypeOptions.push({ Id: o.Id, Name:l, Description: l, Active: true});
        }

        this.dealTypeOptions = new Array();
        for (let o of this.options[2]) {
            let l = o.Description;
            this.dealTypeOptions.push({ Id: o.Id, Name: l, Description: l, Active: true });
        }
    }

    messageSourceTypeOnChange() {
        if (this.selectedMessageSourceTypeId == 1) {
            this.isPaginator = true;
            this.loadMessages(0, this.rowsPerPage, this.searchText);
            this.dataView.first = 0;
        }            
        else {
            this.isPaginator = false;
            this.loadMessages(0, this.rowsPerPage, '');
        }
    }

    removeHTML(str) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = str;
        return tmp.textContent || tmp.innerText || "";
    }

    UpdateMessageFavorite(message: any) {        
        this.messageService.UpdateMessageFavorite(message).subscribe(
            result => {
                if (result) {
                    var newFavStatus = !message.IsFavorite;
                    message.IsFavorite = newFavStatus;
                }                    
            },
            error => {
                this.alertService.SetMessage('error', 'There is an error while Update Favorite');
            }
        );

    }

    OpenSettingDialog() {
        this.showSettingDialog = true;
    }

    saveUserSetting() {
        this.showSettingDialog = false;
        this.messageService.UpdateMessageSetting(this.userSettings).subscribe(
            result => {
                if (result) {
                    this.cloneUserSettings = utility.cloneObject(this.userSettings);     
                    this.loadMessages(0, this.rowsPerPage, '');
                }
            },
            error => {
                this.alertService.SetMessage('error', 'There is an error while Update Setting');
            }
        );
    }

    cancelUserSetting() {
        this.showSettingDialog = false;
        this.InitCheckboxOptions();
    }
}
